<template>
  <div class="container">
    <iframe id="iframe-lesson" :src="iframeUrl" frameborder="0" @load="loaded"></iframe>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    hiddenClass: {
      type: Array,
      default: () => []
    },
    isCourse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // iframeUrl: ''
    }
  },
  computed: {
    iframeUrl() {
      const isDev = process.env.NODE_ENV === 'development'
      const origin = isDev ? 'http://localhost:5565' : ''
      const type = this.type === 'teaching' ? 'player' : this.type
      const path = `/creator-editor/lesson/${type}?id=${this.id}&isFrame=1${
        this.isCourse ? `&isCourse=${this.isCourse}` : ''
      }`
      return origin + path
    }
  },
  methods: {
    loaded() {
      if (!this.hiddenClassName || this.hiddenClassName.length === 0) return
      const event = {
        type: 'hiddenDom',
        data: {
          hiddenClassName: this.hiddenClassName
        }
      }
      this.postMessage(event)
    },
    editorBack() {
      const event = {
        type: 'back',
        data: {
          checkKeys: ['title']
        }
      }
      this.postMessage(event)
    },
    receiveMessage(event) {
      const originArr = ['//pt.qa.growlib.com', '//pt.growlib.com', '//localhost:5565']
      if (!originArr.find(item => event.origin.indexOf(item))) return
      if (event.data.type === 'back') {
        this.$emit(event.data.type, false)
      } else {
        this.$emit(event.data.type, event.data.data)
      }
    }
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false) // 获取iframe传来的信息
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
